import React from "react";
import { useSelector } from "react-redux";
import { Box, Typography, Divider } from "@mui/material";
import { API_CALL_STATUS } from "../../assets/constants/constants";
import Loader from "../../components/loader/Loader";
import CreateAndEditPostForm from "../../components/CreateAndEditPostForm";

const CreateAndEditPostPage = () => {
  const postStatus = useSelector((state) => state.post.status);
  const myPost = useSelector((state) => state.post.myPost);

  return (
    <Box
      sx={{
        height: { xs: "calc(100vh - 56px)", md: "calc(100vh - 64px)" },
        overflowY: "auto",
        boxSizing: "border-box",
        backgroundColor: "#f0f4f8",
        scrollbarWidth: "thin",
        scrollbarColor: "#d0d0d0 transparent",
        "&::-webkit-scrollbar": { width: "4px" },
        "&::-webkit-scrollbar-track": { background: "transparent" },
        "&::-webkit-scrollbar-thumb": { background: "#d0d0d0", borderRadius: "4px" },
      }}
    >
      {postStatus === API_CALL_STATUS.LOADING && <Loader />}

      <Box
        sx={{
          p: { xs: 2, md: 3 },
        }}
      >
        {/* Header */}
        <Box
          sx={{
            backgroundColor: "#001d3d",
            borderRadius: "12px",
            p: { xs: 2.5, md: 4 },
            mb: 3,
          }}
        >
          <Typography
            variant="h4"
            sx={{ color: "#fff", fontWeight: 700, mb: 0.5, fontSize: { xs: "1.6rem", sm: "2rem" } }}
          >
            {Object.keys(myPost).length === 0 ? "Create Post" : "Edit Post"}
          </Typography>
          <Typography variant="body1" sx={{ color: "rgba(255,255,255,0.75)", mb: 0.5 }}>
            Let other people know that you are looking for a roommate.
          </Typography>
          <Typography variant="body2" sx={{ color: "rgba(255,255,255,0.5)" }}>
            This will help you and others to find the correct person as your roommate.
          </Typography>
        </Box>

        {/* Form */}
        <Box
          sx={{
            backgroundColor: "#001d3d",
            borderRadius: "12px",
            p: { xs: 2.5, md: 4 },
          }}
        >
          <CreateAndEditPostForm myPost={myPost} />
        </Box>
      </Box>
    </Box>
  );
};

export default CreateAndEditPostPage;
